"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArrayOfIDsValue = exports.isArrayOfValidObjectsValue = exports.isArrayOfObjectsWithKeysValue = exports.isArrayOfNumbersValue = exports.isArrayOfStringsValue = exports.isArrayOfObjectsValue = exports.isArrayValue = void 0;
const objects_1 = require("./objects");
const primitives_1 = require("./primitives");
const id_1 = require("./id");
/**
 * Checks if the provided value is an array of any type
 * @example: isArrayValue(["1"]) -> true
 * @example: isArrayValue(["1", 1]) -> true
 * @example: isArrayValue({}) -> false
 */
const isArrayValue = (fieldValue) => Array.isArray(fieldValue);
exports.isArrayValue = isArrayValue;
const isArrayOfObjectsValue = (fieldValue) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((obj) => (0, objects_1.isObjectLikeValue)(obj));
};
exports.isArrayOfObjectsValue = isArrayOfObjectsValue;
const isArrayOfStringsValue = (fieldValue) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((item) => (0, primitives_1.isStringValue)(item));
};
exports.isArrayOfStringsValue = isArrayOfStringsValue;
/**
 * Checks if the provided value is an array of numbers
 * @param fieldValue
 */
const isArrayOfNumbersValue = (fieldValue) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((item) => (0, primitives_1.isNumberValue)(item));
};
exports.isArrayOfNumbersValue = isArrayOfNumbersValue;
/**
 * Checks if the provided value is an array of objects with specific keys
 * @param fieldValue
 * @param keysToCompare
 */
const isArrayOfObjectsWithKeysValue = (fieldValue, keysToCompare) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((obj) => {
        if (!(0, objects_1.isObjectLikeValue)(obj))
            return false;
        return (0, objects_1.isObjectWithKeysValue)(obj, keysToCompare);
    });
};
exports.isArrayOfObjectsWithKeysValue = isArrayOfObjectsWithKeysValue;
/**
 * Checks if the provided value is an array of objects with keys and values of a specific type
 * @param fieldValue
 * @param typeCheckObject
 * @param passThrough
 */
const isArrayOfValidObjectsValue = (fieldValue, typeCheckObject, passThrough = false) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((obj) => {
        if (!(0, objects_1.isObjectLikeValue)(obj))
            return false;
        return (0, objects_1.isValidObjectValue)(obj, typeCheckObject, passThrough);
    });
};
exports.isArrayOfValidObjectsValue = isArrayOfValidObjectsValue;
const isArrayOfIDsValue = (fieldValue) => {
    if (!(0, exports.isArrayValue)(fieldValue))
        return false;
    return fieldValue.every((item) => (0, id_1.isNotEmptyIDValue)(item));
};
exports.isArrayOfIDsValue = isArrayOfIDsValue;
